import { z } from 'zod';
// Login Validation Schema
export const loginSchema = z.object({
  username: z.string().min(1, 'Please enter your username'),
  password: z.string().min(1, 'Please enter a password'),
  // captcha: z.string().trim().min(1, { message: 'Captcha is required' }),
});

export type LoginFormData = z.infer<typeof loginSchema>;
